var _style, _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _g6, _circle7, _g7, _circle8, _g8, _circle9, _g9, _circle10, _g10, _circle11, _g11, _circle12, _g12, _line, _rect, _path3, _g13, _rect2, _path4, _g14, _rect3, _path5, _g15, _rect4, _path6, _g16, _rect5, _path7, _g17, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 112",
    style: {
      enableBackground: "new 0 0 210 112"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#585E65;}\n\t.st1{fill:#9FA0A4;}\n\t.st2{fill:#08161F;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;}\n\t.st5{fill:#E6E6E6;}\n\t.st6{fill:#C80502;}\n\t.st7{fill:#EDEDED;}\n\t.st8{fill:#323232;}\n\t.st9{fill:#FAFAFA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.6,50.8c-2,0-3.8-1.1-4.8-3.1c-1.3-2.4-0.9-5,1-6.8c3.8-3.6,11.5-7.2,11.8-7.4l0.6,1.3 c-0.1,0-7.8,3.7-11.4,7.1c-1.7,1.6-1.4,3.8-0.7,5.1c0.7,1.3,2.3,2.7,4.4,2.2c1.2-0.3,2.8-1.2,4.6-2.2c1.9-1.1,4.4-2.4,7.2-3.5 l0.5,1.3c-2.8,1-5,2.3-7.1,3.4c-2,1.1-3.6,2-5,2.3C109.3,50.8,109,50.8,108.6,50.8L108.6,50.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,103.8c-3.1,0-6-0.5-8.4-1.6C12.1,98.4,9.5,89.8,8.1,82c-0.2-0.7-2.5-15.3,1.2-22c1.6-2.9,4-4.8,7-5.5 c3.8-0.9,7.4,0.2,9.4,1.5c2.8,1.8,5.1,2.3,6.2,1.3c0.8-0.7,1-2.1,0.4-3.6c0-0.1-0.1-0.2-0.1-0.4c-2.9-7.6-5.8-18.2-2.8-25.2 c1.8-4.2,5.4-7.3,10.1-8.7c4.8-1.4,10.4-1,15.8,1.3c0.5,0.2,1,0.4,1.5,0.7c5.1,2.2,13.6,5.8,21.6,5.1c3.8-0.3,8.4-3,13.3-5.8 c3.6-2.1,7.4-4.3,11.2-5.7c6.3-2.4,18-2.9,21.4-3c4.9-0.1,10.5,1.6,11.5,6.7c0.6,2.9,0.1,5.1-1.6,7.1c-1.8,2.1-5,4-10.2,6 c-9.8,3.8-13.7,9.2-13,11c0.5,1.5,1.7,2.7,6.8,1.2c0.7-0.2,1.6-0.5,2.8-0.9c7.7-2.6,23.6-7.9,35.7-4c5.3,1.7,14,8,21,13.3 c3.4,2.6,14.1,11.1,15.5,12.3c5.9,5.5,6.9,10.4,6.6,13.5c-0.3,3.9-2.6,7.4-6.3,9.9c-4.9,3.3-10.1,2.8-15.5-1.6 c-2.1-1.8-4.8-5.6-7.9-10.1c-1.9-2.8-4-5.8-6.1-8.5c-6.1-7.8-15.1-9.5-26.7-5c-2.9,1.1-7.8,3.1-14.7,5.9c-3.7,1.5-8,3.3-12.8,5.2 c-3.3,1.4-6.7,2.8-10.2,4.2c-4.8,2-9.8,4-14.6,6c-2.1,0.9-4.2,1.7-6.2,2.6c-3,1.2-6,2.6-9.3,4C55.3,97.2,40.1,103.8,28.7,103.8 L28.7,103.8z M19.1,56.2c-0.8,0-1.6,0.1-2.3,0.3c-2.4,0.6-4.3,2.1-5.7,4.5c-3.4,6-1.1,20.4-1,20.6c1.4,7.3,3.8,15.3,11,18.7 c10.6,4.9,30.1-3.5,47.2-11c3.2-1.4,6.3-2.7,9.3-4c2.1-0.8,4.2-1.7,6.2-2.6l0,0c4.8-2,9.8-4.1,14.6-6c3.5-1.4,6.9-2.8,10.2-4.2 c4.7-1.9,9-3.7,12.8-5.2c6.9-2.8,11.8-4.8,14.7-5.9c7.4-2.9,14-3.3,19.5-1.4c3.7,1.3,6.9,3.7,9.5,7.1c2.1,2.8,4.2,5.7,6.1,8.6 c2.9,4.2,5.6,8.1,7.5,9.7c4.6,3.8,8.9,4.2,13.1,1.5c3.2-2.2,5.2-5.1,5.4-8.4c0.3-3.9-1.8-8-6-11.9c-1.2-1.2-11.7-9.4-15.3-12.2 c-6.3-4.8-15.3-11.4-20.4-13c-11.5-3.7-27,1.5-34.4,4c-1.2,0.4-2.2,0.7-2.9,0.9c-2.7,0.8-4.7,1-6.2,0.5c-1.5-0.4-2.6-1.4-3.2-3 c-0.6-1.8,0.4-4.2,2.9-6.7c1.8-1.9,5.3-4.6,11.3-6.9c10.9-4.2,11.2-7.4,10.5-10.9c-1-5-8-5.1-9.4-5.1c-2.4,0.1-14.6,0.5-20.7,2.9 c-3.7,1.4-7.3,3.5-10.9,5.6c-5.1,2.9-9.8,5.7-14.1,6.1c-8.6,0.8-17.4-3-22.6-5.3c-0.5-0.2-1.1-0.5-1.5-0.6 c-4.9-2.1-10.1-2.5-14.4-1.2c-4.1,1.2-7.3,3.9-8.8,7.5C29.7,32.6,29,39.6,34,52.7c0.1,0.2,0.1,0.3,0.1,0.4c0.9,2.3,0.5,4.6-1.1,5.8 c-1.1,0.9-3.7,1.9-8.6-1.2C23.2,56.9,21.2,56.2,19.1,56.2L19.1,56.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 151,
    cy: 66.6,
    r: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.1,67.7h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5L151,65h0.6v2.8h0.7v0.5h-2.1L150.1,67.7L150.1,67.7z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 203.4,
    cy: 84.7,
    r: 3.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.4,85.8c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.7,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.7,0,1.1,0.3,1.1,1V84c0,0.6-0.2,0.8-0.7,1l-0.4,0.1c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5 h-2.2V85.8z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 152.2,
    cy: 32.7,
    r: 3.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.1,34.1l0.1-0.5c0.2,0.1,0.6,0.2,0.9,0.2c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5h-0.4v-0.5h0.3 c0.4,0,0.6-0.1,0.6-0.4l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2l-0.2-0.5c0.3-0.1,0.7-0.2,1.1-0.2c0.6,0,1.1,0.2,1.1,0.8v0.1 c0,0.3-0.2,0.6-0.5,0.7l0,0c0.3,0.1,0.6,0.3,0.6,0.8v0.1c0,0.7-0.4,1-1.2,1C151.7,34.3,151.3,34.3,151.1,34.1z"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 99.5,
    cy: 51.1,
    r: 3.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,52.1h-1.6v-0.4l1.1-2.2h0.8l-1.1,2h0.8v-0.9h0.7v0.9h0.4v0.6h-0.4v0.6h-0.7V52.1z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 117.8,
    cy: 26.2,
    r: 3.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119,26.7L119,26.7c0,0.8-0.4,1.1-1.2,1.1c-0.6,0-0.9-0.1-1.1-0.3l0.2-0.5c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5c-0.2,0-0.5,0-0.7,0l-0.1-0.2l0.1-1.6h1.8V25h-1.3l-0.1,0.7c0.1,0,0.2,0,0.3,0 C118.6,25.7,119,26,119,26.7z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 141.6,
    cy: 21.1,
    r: 3.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.8,21.6L142.8,21.6c0,0.7-0.4,1.1-1.2,1.1c-1,0-1.2-0.5-1.2-1.6V21c0-1.4,0.5-1.7,1.3-1.7 c0.3,0,0.6,0.1,0.8,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.6,0.1-0.7,0.8c0.2,0,0.4,0,0.6,0 C142.4,20.6,142.8,20.8,142.8,21.6z M142.2,21.6c0-0.4-0.1-0.5-0.5-0.5c-0.2,0-0.3,0-0.5,0c0,0.7,0.1,1,0.5,1 C142,22.2,142.2,22,142.2,21.6L142.2,21.6z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 103.1,
    cy: 9.2,
    r: 3.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,8H102V7.5h2.3V8l-1.3,2.9h-0.8L103.6,8z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 80.4,
    cy: 20.4,
    r: 3.5
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.6,21L81.6,21c0,0.7-0.4,1-1.2,1c-0.8,0-1.2-0.3-1.2-1l0,0c0-0.4,0.2-0.6,0.5-0.8c-0.2-0.1-0.4-0.4-0.4-0.7 l0,0c0-0.6,0.4-0.9,1.2-0.9c0.7,0,1.1,0.3,1.1,0.9l0,0c0,0.3-0.1,0.6-0.4,0.7C81.5,20.4,81.6,20.6,81.6,21z M80.9,21 c0-0.3-0.1-0.5-0.5-0.5l0,0c-0.3,0-0.5,0.1-0.5,0.5l0,0c0,0.3,0.1,0.5,0.5,0.5S80.9,21.3,80.9,21L80.9,21z M80,19.6 c0,0.3,0.1,0.4,0.4,0.4l0,0c0.3,0,0.4-0.2,0.4-0.4l0,0c0-0.3-0.1-0.4-0.4-0.4C80.1,19.1,80,19.3,80,19.6L80,19.6z"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.9,
    cy: 18.3,
    r: 3.5
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,17.8v0.6c0,0.9-0.2,1.5-1.2,1.5c-0.4,0-0.7-0.1-1-0.1l0.1-0.6c0.2,0.1,0.6,0.1,0.8,0.1 c0.4,0,0.6-0.2,0.6-0.7c-0.2,0-0.4,0-0.6,0c-0.8,0-1.1-0.3-1.1-1.1v-0.1c0-0.7,0.4-1.1,1.2-1.1C30.8,16.5,31.2,16.9,31.2,17.8z  M30,18.2c0.2,0,0.3,0,0.5,0V18c0-0.7-0.1-1-0.5-1s-0.5,0.2-0.5,0.5l0,0C29.5,18,29.6,18.2,30,18.2z"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 38.2,
    cy: 61.7,
    r: 3.5
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,62.8h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8H38v0.5h-2.1v-0.6H35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,63.1c-0.2-0.2-0.3-0.6-0.3-1.4v-0.1c0-0.7,0.1-1.1,0.3-1.3s0.5-0.3,0.9-0.3c0.5,0,0.7,0.1,0.9,0.3 c0.2,0.3,0.3,0.6,0.3,1.3v0.1c0,0.8-0.1,1.1-0.3,1.3s-0.5,0.3-0.9,0.3C39.2,63.4,38.9,63.3,38.7,63.1z M40,62.7 c0.1-0.2,0.1-0.5,0.1-1v-0.1c0-0.5,0-0.8-0.1-1c-0.1-0.1-0.2-0.1-0.4-0.1s-0.3,0-0.4,0.1c-0.1,0.2-0.1,0.5-0.1,1v0.1 c0,0.5,0,0.8,0.1,1c0.1,0.1,0.2,0.2,0.4,0.2C39.8,62.8,40,62.8,40,62.7z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.6,
    cy: 51.9,
    r: 3.5
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.2,53H5v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6V53h0.7v0.5H4.2V53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,53h0.8v-2.1l0,0L7,51.1l-0.1-0.5l0.9-0.3h0.6V53h0.7v0.5H7V53z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 17.6,
    cy: 107.1,
    r: 3.5
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,108.2H16v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8h0.7v0.5h-2.1C15.3,108.8,15.3,108.2,15.3,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,108.1c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.7,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.7,0,1.1,0.3,1.1,1v0.1c0,0.6-0.2,0.8-0.7,1l-0.4,0.1c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5 h-2.2V108.1z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 83,
    y1: 80.8,
    x2: 86.4,
    y2: 88.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.3,
    y: 80.5,
    transform: "matrix(0.9178 -0.3971 0.3971 0.9178 -26.7014 40.5884)",
    className: "st5",
    width: 0.7,
    height: 8.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90.2,87.6h-8.4l0,0v7.7h8.5L90.2,87.6L90.2,87.6z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.2,90c0-0.6,0.3-0.9,0.9-0.9h2v0.8h-1.7c-0.1,0-0.2,0.1-0.2,0.2V91H86v0.8h-1.8v1.9h-1V90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.1,93.1v-4h1v3.8c0,0.1,0,0.1,0.1,0.1h1.4v0.8h-1.8C87.2,93.8,87.1,93.6,87.1,93.1z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 60.6,
    transform: "matrix(0.632 -0.7749 0.7749 0.632 22.7125 169.738)",
    className: "st7",
    width: 11.2,
    height: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.6,53.6h-8.4l0,0v7.7h8.5L199.6,53.6L199.6,53.6z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193,54.8h1v0.9h-1V54.8z M193.1,56.2h0.9v3.5h-0.9V56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.1,59h1.1v-3l0,0l-1,0.3l-0.2-0.8l1.3-0.4h0.9V59h1v0.8h-3V59H195.1z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 48,
    transform: "matrix(0.9625 -0.2711 0.2711 0.9625 -12.0448 9.4826)",
    className: "st7",
    width: 12,
    height: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.3,44.2h-8.4l0,0v7.7h8.5L25.3,44.2L25.3,44.2z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.7,45.4h1v0.9h-1V45.4z M18.8,46.8h0.9v3.5h-0.9V46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.5,50.1l0.1-0.8c0.3,0.2,0.8,0.3,1.3,0.3c0.6,0,0.9-0.2,0.9-0.7v-0.1c0-0.5-0.3-0.7-0.8-0.7h-0.6v-0.8h0.4 c0.6,0,0.8-0.1,0.8-0.6v-0.1c0-0.4-0.3-0.5-0.7-0.5c-0.5,0-0.9,0.1-1.2,0.3l-0.2-0.8c0.4-0.2,0.9-0.3,1.5-0.3 c0.8,0,1.5,0.3,1.5,1.2v0.1c0,0.5-0.2,0.9-0.7,1l0,0c0.5,0.1,0.8,0.5,0.8,1.1V49c0,1-0.6,1.4-1.8,1.4 C21.4,50.4,20.9,50.3,20.5,50.1z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 4.8,
    transform: "matrix(0.9975 -7.080040e-02 7.080040e-02 0.9975 -0.4688 8.2717)",
    className: "st7",
    width: 0.7,
    height: 11.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.3,1.4h-8.4l0,0v7.7h8.5L121.3,1.4L121.3,1.4z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.8,2.7h1v0.9h-1V2.7z M114.9,4h0.9v3.5h-0.9V4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.8,6.8c0-1,0.3-1.4,1-1.6l0.5-0.2c0.4-0.1,0.5-0.2,0.5-0.7l0,0c0-0.4-0.3-0.6-0.8-0.6s-0.9,0.1-1.2,0.3 l-0.2-0.8c0.3-0.2,0.9-0.3,1.5-0.3c0.9,0,1.6,0.4,1.6,1.4v0.1c0,0.8-0.3,1.2-1,1.4L118.1,6c-0.5,0.1-0.7,0.4-0.7,0.8V7h2.1v0.8 h-3.1v-1H116.8z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118.6,
    y: 66.3,
    transform: "matrix(0.9313 -0.3642 0.3642 0.9313 -17.5492 48.1679)",
    className: "st7",
    width: 0.7,
    height: 8.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123,73.4h-5.9l0,0v6.4h5.9V73.4L123,73.4z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M118.9,78.3l0.2-0.6c0.3,0.1,0.7,0.2,1,0.2c0.5,0,0.7-0.1,0.7-0.5l0,0c0-0.3-0.1-0.4-0.5-0.5l-0.4-0.1 c-0.7-0.2-1-0.4-1-1.1v-0.1c0-0.8,0.5-1.1,1.4-1.1c0.4,0,0.9,0.1,1.2,0.2l-0.2,0.7c-0.3-0.1-0.7-0.2-0.9-0.2c-0.4,0-0.6,0-0.6,0.4 l0,0c0,0.3,0.1,0.4,0.5,0.4l0.5,0.1c0.7,0.1,0.9,0.4,0.9,1.1v0.1c0,0.9-0.5,1.2-1.5,1.2C119.7,78.6,119.1,78.5,118.9,78.3z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 90.2,
    className: "st9",
    width: 0.9,
    height: 5.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 91.1,
    width: 0.9,
    height: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 92.8,
    width: 0.9,
    height: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 94.5,
    width: 0.9,
    height: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90.2,
    className: "st9",
    width: 0.9,
    height: 5.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90.2,
    width: 0.9,
    height: 0.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 92,
    width: 0.9,
    height: 0.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 93.7,
    width: 0.9,
    height: 0.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 87.6,
    className: "st9",
    width: 0.9,
    height: 2.6
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 87.6,
    width: 0.9,
    height: 0.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 89.4,
    width: 0.9,
    height: 0.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 87.6,
    className: "st9",
    width: 0.9,
    height: 2.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 88.5,
    width: 0.9,
    height: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.f93508f2b4459666d1e8a847ecf513d6.svg";
export { ForwardRef as ReactComponent };